import FloatingActionButton from "@components/FloatingActionButton";
import { CreatePlaylistModalSWMSheet } from "@components/modals/CreatePlaylistModalSWM";
import type { SharedValue } from "react-native-reanimated";
import { useBottomSheetManager } from "react-native-bottom-sheet-stack";

const CreatePlaylistButton = (_props: { y: SharedValue<number> }) => {
  const bottomSheetManager = useBottomSheetManager();

  return (
    <FloatingActionButton
      onPress={() => {
        bottomSheetManager.open(<CreatePlaylistModalSWMSheet />, {
          mode: "push",
        });
      }}
      sentryEventName="library_create_playlist_button"
      tipName="create-playlist"
    />
  );
};

export default CreatePlaylistButton;
